 import React from "react";
import { Box, Button, Typography } from "@mui/material";
import StyledLinkExpired from "./StyledLinkExpired";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTE_PATH } from "../../constants/route";
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { useDispatch } from "react-redux";
import { fetchForgetPassword } from "../../store/reducers/authentication/apiThunk";
import { ToastNotifyError, ToastNotifySuccess } from "../../components/CommonComponents/Toast/ToastNotify";

const LinkExpired = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { data } = location.state || {};

    const sendResendLink = async () => {
        const dataToSend = {
            email: data,
          };
        try {
          const response = await dispatch(fetchForgetPassword(dataToSend));
          const { status, message } = response?.payload || {};
    
          if (status) {
            ToastNotifySuccess(message);
            navigate(ROUTE_PATH.FORGET_PASSWORD_CHECK_INBOX, {state: {data}});
          }
        } catch (error) {
          ToastNotifyError("An error occurred. Please try again.");
        }
      };

  return (
    <StyledLinkExpired>
      <Box className="linkExpired-wrap">
        <Box className="linkExpired-header">
            <Box className="circleIcon">
                <ErrorOutlineOutlinedIcon sx={{ fontSize: "35px", color: "#B60218" }} />
            </Box>
          <Typography className="header">Link Expired</Typography>
        </Box>
        <Box className="body-wrap">
          <Typography className="body-text">
          Oops! This link has expired. For your security, reset links are valid for only 30 minutes.
          </Typography>
        </Box>
        <Box className="resend-link-btn">
            <Button variant="contained" color="primary" className="custom-button" onClick={() => sendResendLink()}>
                Request an new reset link
            </Button>
        </Box>
        <Typography className="body-text-2"><span>Didn't receive the email?</span> Check your spam folder or try again</Typography>
        <Box className="backLogin">
          <Link to={ROUTE_PATH.LOGIN}>Back to login</Link>
        </Box>
      </Box>
    </StyledLinkExpired>
  );
};

export default LinkExpired;

